import React, { useState, useEffect, useReducer } from "react";
import { Alert, Button, Card, Table } from "react-bootstrap";
import axios from "../../../../../config/axios";
import { Link } from "react-router-dom";
import UpdateQuestionModal from "./UpdateQuestionModal";
import PollQuestionOptions from "./PollQuestionOptions";
import useConfirm from "../../../../../HOC/custom/useConfirm";
import { listingReducer, listingInitialState } from "../../reducers/listingReducer";
import { toastNotification } from "../../../../../config/toastNotification";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";

const PollQuestionItem = ({ question, loadData }) => {
  const [showUpdateQuestionModal, setShowUpdateQuestionModal] = useState(false);
  const { confirm } = useConfirm();
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );

  const confirmAndDeleteQuestion = async (id) => {
    const isConfirmed = await confirm(
      `Do you really want to delete this question?`
    );

    if (isConfirmed) {
      try {
        listingDispatch({
          type: "BLOCK_REQUEST",
        });
        const res = await axios.delete(`poll-questions/delete-question/${id}`);
        loadData();
        // listingDispatch({
        //     type: "DELETE_SUCCESS"
        // });
        toastNotification.addNotification({
          ...toastNotification,
          title: "Success!",
          message: `Question deleted successfully.`,
          type: "success",
        });
      } catch (error) {
        listingDispatch({
          type: "BLOCK_FAILURE",
          payload: error,
        });

        setTimeout(() => {
          listingDispatch({
            type: "REMOVE_ERROR",
          });
        }, 5000);
      }
    }
  };


  return (
    <>
      <div class="questionItem">
        <Card className="item mb-2">
          <Card.Header className="ps-1 pe-2 py-0">
            <Card.Title className="d-flex m-0 p-0 px-1">
              <div className="d-flex ImageSectionSpacing">
                <div className="d-flex flex-column ms-1">
                  <span className="m-0 text-bold memberName">{question.question}</span>
                  <span class=" font-small font-weight-bold mt-1 text-success fs-6  ">
                    <span class="membershipId">Submissions Count: <b>{question.submissionsCount}</b></span>
                  </span>
                </div>
              </div>

            </Card.Title>


            <div class="card-tools mb-1">
              <div className=" text-right me-xl-2  mt-1">
                <span
                  className="btn btn-outline-secondary  listingActionIcon me-1"
                  title="Update Item"
                  onClick={() => setShowUpdateQuestionModal(true)}
                >
                  <i className="fas fa-pencil-alt"></i>
                </span>
                <span
                  className="btn btn-outline-secondary  listingActionIcon"
                  title="Delete Item"
                  onClick={() => confirmAndDeleteQuestion(question._id)}
                >
                  <i className="fas fa-trash"></i>
                </span>

              </div>
            </div>

          </Card.Header>

          <Card.Body className="px-3 py-2">

            <PollQuestionOptions question={question} loadData={loadData} />
          </Card.Body>
        </Card>
      </div>
      <UpdateQuestionModal
        show={showUpdateQuestionModal}
        setShow={setShowUpdateQuestionModal}
        question={question}
        loadItem={loadData}
      />
    </>

  );
};

export default PollQuestionItem;
